<div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> {{captureRole}}</h3>
    <div>
        <!-- <button
      [disabled]="enableCopy && !(copySource && copySource.selectedClientData && copySource.selectedClientData.length == 0)"
      nz-button nzType="primary" (click)="EmitOpenSearchModal()">
      Search / Add {{captureRole}}
    </button> -->

        <button nz-button nzType="primary" (click)="EmitOpenSearchModal()">
            Search {{captureRole}}
        </button>

    </div>

</div>
<div class="search-results m-t-20">
    <nz-table *ngIf="agentList && agentList.selectedClientData && agentList.selectedClientData.length > 0"
        [nzShowPagination]="false" #agentSearchTable [nzData]="[1]">
        <thead>
            <tr>
                <th>Intermediary No</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Channel Name</th>
                <!-- <th>Source</th> -->
                <th>Commission Split</th>
                <!-- <th>Primary Agent</th> -->
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let data of agentList?.selectedClientData; let i=index">
                <!-- <ng-container *ngFor="let clientData of data; let j=index"> -->
                <tr *ngIf="data.agentNum">
                    <td>{{data?.agentNum}}</td>
                    <td>{{data?.firstName}}</td>
                    <td>{{data?.lastName}}</td>
                    <td>{{data?.channel | technicalTranslate}}</td>
                    <!-- <td>-</td> -->
                    <td *ngIf="transactionState != 'proposal_DataEntry'">{{data?.commissionPercent}}%</td>
                    <td *ngIf="transactionState == 'proposal_DataEntry'">
                        <nz-input-number [(ngModel)]="data.commissionPercent" [nzMin]="1" [nzMax]="100" [nzStep]="1"
                            [nzFormatter]="formatterPercent" [nzParser]="parserPercent"></nz-input-number>
                    </td>
                    <!-- <td [class.inputs-are-disabled]="transactionState != 'proposal_DataEntry'">
                        <label nz-checkbox [(ngModel)]="data.primaryFl"></label>
                    </td> -->
                    <td>
                        <a [class.inputs-are-disabled]="transactionState != 'proposal_DataEntry'" nz-popconfirm
                            nzPopconfirmTitle="Remove row?" nzOkText="Remove" nzCancelText="Cancel"
                            (nzOnConfirm)="removeAgent(data.guid)">Remove</a>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </nz-table>
    <app-generic-zero-ui [list]="agentList?.selectedClientData" icon="file-search" [title]="agentZeroState.title"
        [message]="agentZeroState.message">
    </app-generic-zero-ui>
</div>